import { createContext, useContext, useState } from 'react';

const MobileNavContext = createContext(null);

export const MobileNavProvider = ({ children }) => {
  const [subNav, setSubNav] = useState(null);
  return (
    <MobileNavContext.Provider value={{ subNav, setSubNav }}>
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileSubNav = () => useContext(MobileNavContext);
